import React, { useState, useEffect, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import { Dropdown, Modal, Button, Offcanvas } from "react-bootstrap";
import NewAppointment from "../Appointment/NewAppointment";
import BrandLogo from "../BrandLogo/BrandLogo";
import { useNavigate } from "react-router-dom";
import { LuBell } from "react-icons/lu";
import { LuSearch } from "react-icons/lu";
import { RiDeleteBinLine } from "react-icons/ri";
import {
  MdOutlineNotificationsActive,
  MdOutlineNotificationsNone,
  MdKeyboardArrowDown,
  MdOutlineBusinessCenter
} from "react-icons/md";
import * as apicall from "../Apicall";
import { TbLogout } from "react-icons/tb";
import { MdPersonOutline } from "react-icons/md";
import { IoIosHelpCircle } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import * as constants from "../../constants/Constants";
import HelpPanel from "../Help/HelpPanel";
import BusinessInfoSidebar from "./BusinessInfoSidebar";
import { canSeeAccountOwnerInfo } from "../../constants/roles";
import { fetchEzpNotifications, isEzpId, markEzpRead, deleteEzp, mergeNotifications, notificationTarget } from "../../utils/ezpNotifications";
import useViewport from "../../hooks/useViewport";
import { getPlanLabel } from "../../utils/planLabels";
import { useMobileNav } from "../MobileNav/MobileNavContext";
import "../MobileNav/mobileNav.css";
import useNavPrefs, { openNavSearch } from "../NavV2/navPrefs";
import { MdOutlineViewSidebar } from "react-icons/md";
import "../NavV2/navV2.css";

const Navbar = ({ toggleSidebar, vendorDataPass }) => {
  const navigate = useNavigate();
  // Profile menu item, setup-completion pill, and billing plan are account-
  // owner chrome - only Vendor (the actual account owner) or Super Admin
  // should see it. Admin/Crew/Support are staff, not account owners.
  const showAccountOwnerInfo = canSeeAccountOwnerInfo(apicall.getRole());
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [loading, setLoading] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [support, setSupport] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showBusinessInfo, setShowBusinessInfo] = useState(false);
  const [vendorProfileData, setVendorProfileData] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [deletedNotif, setdeletedNotif] = useState([]);
  const bellRef = useRef(null);
  const supportRef = useRef(null);
  const helpRef = useRef(null);
  const [setupCompleted, setSetupCompleted] = useState();
  const [completedSteps, setCompletedSteps] = useState({
    profile: false,
    service: false,
    type: false,
    crew: false,
    order: false
  });
  const vendorId = localStorage.getItem("vendorId");
  const [vendorLogo, setVendorLogo] = useState(null);
  const [isClinicService, setIsClinicService] = useState(false);
  const [isHomeService, setIsHomeService] = useState(false);
  const [isCarService, setIsCarService] = useState(false);
  const [isSportsService, setIsSportsService] = useState(false);

  const [showAppointmentPanel, setShowAppointmentPanel] = useState(false);
  const pollingInterval = useRef(null);
  const [hoveredDelete, setHoveredDelete] = useState(null);

  // Store read status in localStorage to persist between refreshes
  const [readNotifications, setReadNotifications] = useState(() => {
    const saved = localStorage.getItem("readNotifications");
    return saved ? JSON.parse(saved) : [];
  });

  // Store deleted notifications to prevent showing them again
  const [deletedNotifications, setDeletedNotifications] = useState(() => {
    const saved = localStorage.getItem("deletedNotifications");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem(
      "readNotifications",
      JSON.stringify(readNotifications)
    );
    localStorage.setItem(
      "deletedNotifications",
      JSON.stringify(deletedNotifications)
    );
  }, [readNotifications, deletedNotifications]);

  // Add polling mechanism
  useEffect(() => {
    const startPolling = () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
      }
      pollingInterval.current = setInterval(() => {
        if (vendorId) {
          fetchNotifications(vendorId);
        }
      }, 30000);
    };

    startPolling();

    return () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
      }
    };
  }, [vendorId]);

  useEffect(() => {
    const fetchVendorProfile = async () => {
      try {
        const [response] = await Promise.all([apicall.get("ezpMyProfile")]);

        if (response.status === 200 && response.success) {
          const vendorData = response.data[0];
          console.log(vendorData, "vendorData");
          setVendorProfileData(vendorData);
          localStorage.setItem("vendorProfile", JSON.stringify(vendorData));

          localStorage.setItem("vendorId", vendorData.vendor_id);
          localStorage.setItem("currency", vendorData.currency || "INR");
          setVendorName(vendorData.first_name);
          setVendorLogo(vendorData.vendor_logo);
          setIsClinicService(Number(vendorData.industry) === 1);
          setIsSportsService(Number(vendorData.industry) === 7);
          setIsCarService(Number(vendorData.industry) === 8);
          setIsHomeService(Number(vendorData.industry) === 2);

          // Initial fetch of notifications
          fetchNotifications(vendorData.vendor_id);
          vendorDataPass(vendorData);
        }
      } catch (error) {
        console.error("Error fetching vendor profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVendorProfile();
  }, []);

  const fetchNotifications = async (vendorId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        constants.apiUrl + "api/v1/notificationsVendor/" + vendorId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.status === 401) {
        // Do NOT refresh token, just return empty
        return [];
      }

      if (!response.ok) {
        throw new Error("Failed to fetch notifications");
      }

      const data = await response.json();
      if (data.status === 200 && data.success) {
        // Filter out deleted notifications and merge with local read status
        const vendorNotifications = data.data
          .filter((notif) => !deletedNotifications.includes(notif.id))
          .map((notif) => ({
            ...notif,
            is_read: readNotifications.includes(notif.id) ? 1 : notif.is_read
          }));
        // Procurement's per-person alerts join the same list (their read/deleted state lives on the server).
        const updatedNotifications = mergeNotifications(vendorNotifications, await fetchEzpNotifications());

        // Only update if there are changes
        if (
          JSON.stringify(notifications) !== JSON.stringify(updatedNotifications)
        ) {
          setNotifications(updatedNotifications);
          setUnreadCount(
            updatedNotifications.filter((n) => n.is_read === 0).length
          );
        }
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const markNotificationAsRead = async (id) => {
    try {
      // Optimistically update UI first
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, is_read: 1 } : n))
      );
      setReadNotifications((prev) => [...prev, id]);
      setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));

      // Then update the API
      await (isEzpId(id) ? markEzpRead(id) : apicall.get(`notificationVendor_readStatus/${id}`));
    } catch (error) {
      console.error("Error marking notification as read:", error);
      // Rollback if API call fails
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, is_read: 0 } : n))
      );
      setReadNotifications((prev) => prev.filter((notifId) => notifId !== id));
      setUnreadCount((prev) => prev + 1);
    }
  };

  const deleteNotification = async (id) => {
    try {
      // Optimistically update UI first
      const deletedNotif = notifications.find((n) => n.id === id);
      setNotifications((prev) => prev.filter((n) => n.id !== id));
      setDeletedNotifications((prev) => [...prev, id]);

      if (deletedNotif && deletedNotif.is_read === 0) {
        setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
      }

      // Then update the API
      await (isEzpId(id) ? deleteEzp(id) : apicall.get(`notificationVendor_delete/${id}`));
    } catch (error) {
      console.error("Error deleting notification:", error);
      // Rollback if API call fails
      if (deletedNotif) {
        setNotifications((prev) => [...prev, deletedNotif]);
        setDeletedNotifications((prev) =>
          prev.filter((notifId) => notifId !== id)
        );
        if (deletedNotif.is_read === 0) {
          setUnreadCount((prev) => prev + 1);
        }
      }
    }
  };

  const deleteAllNotifications = async () => {
    try {
      // Optimistically update UI first
      const unreadToDelete = notifications.filter(
        (n) => n.is_read === 0
      ).length;
      const allIds = notifications.map((n) => n.id);

      setNotifications([]);
      setDeletedNotifications((prev) => [...prev, ...allIds]);
      setUnreadCount((prev) =>
        prev - unreadToDelete > 0 ? prev - unreadToDelete : 0
      );

      // Then update the API
      await Promise.all(
        notifications.map((notif) =>
          isEzpId(notif.id) ? deleteEzp(notif.id) : apicall.get(`notificationVendor_delete/${notif.id}`)
        )
      );
    } catch (error) {
      console.error("Error deleting all notifications:", error);
      // Full rollback is complex here, might want to just refresh notifications
      fetchNotifications(vendorId);
    }
  };

  // Close popup when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (supportRef.current && !supportRef?.current.contains(event.target)) {
        setSupport(false);
      }
      if (helpRef.current && !helpRef.current.contains(event.target)) {
        setShowHelp(false);
      }
    }
    if (showNotifications || support || showHelp) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications, support, showHelp]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const confirmLogout = () => setShowLogoutConfirm(true);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const handleSearchSubmit = (e) => {
    if (e.key === "Enter" && searchQuery.trim()) {
      navigate("/doctors", { state: { searchQuery: searchQuery.trim() } });
      setShowSearch(false);
      setSearchQuery("");
    }
  };
  useEffect(() => {
    const handleSetupUpdate = () => {
      console.log("Setup update event received");
      checkSetupStatus();
    };

    window.addEventListener("setupCompletedUpdated", handleSetupUpdate);

    return () => {
      window.removeEventListener("setupCompletedUpdated", handleSetupUpdate);
    };
  }, []);
  async function checkSetupStatus() {
    try {
      let [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_offerings`),
        apicall.get(`get_ezp_service_providers?skill=PROFESSIONAL`),
        apicall.get(`get_ezp_booking?page=1&limit=1`)
      ]);

      let ans = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0
      };

      let totalPercentage = Object.values(ans).filter((val) => val).length * 20;

      const completed = totalPercentage === 100;

      localStorage.setItem("setupCompleted", completed ? "true" : "false");
      // window.dispatchEvent(new Event("setupCompletedUpdated"));
      localStorage.setItem(
        "userDetails",
        JSON.stringify(ezpMyProfile?.data?.[0])
      );

      setSetupCompleted(completed);
      setCompletedSteps(ans);
      setIsClinicService(Number(ezpMyProfile?.data?.[0]?.industry) === 1);
      setIsCarService(Number(ezpMyProfile?.data?.[0]?.industry) === 8);
      setIsHomeService(Number(ezpMyProfile?.data?.[0]?.industry) === 2);
      setIsSportsService(Number(ezpMyProfile?.data?.[0]?.industry) === 7);
    } catch (e) {
      console.log("Setup status error", e);
    }
  }

  const SETUP_STEPS = [
    { status: "profile", route: "/vendors/view-profile" },
    { status: "service", route: "/admin-setup?tab=categories" },
    { status: "type", route: "/admin-setup?tab=service-types" },
    { status: "crew", route: "/providers" },
    { status: "order", route: null }
  ];

  const navigateToNextPendingStep = async () => {
    try {
      // Always fetch live status — stale state would re-route to the same completed step
      const [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_offerings`),
        apicall.get(`get_ezp_service_providers?skill=PROFESSIONAL`),
        apicall.get(`get_ezp_booking?page=1&limit=1`)
      ]);

      const freshSteps = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0
      };

      const totalPercentage =
        Object.values(freshSteps).filter(Boolean).length * 20;
      const allDone = totalPercentage === 100;
      setCompletedSteps(freshSteps);
      setSetupCompleted(allDone);
      localStorage.setItem("setupCompleted", allDone ? "true" : "false");

      // Use the freshly-fetched ezpMyProfile above instead of localStorage's
      // "userDetails" — that only gets refreshed on login, so right after
      // finishing setup (still the same session) it can still hold the
      // pre-setup industry value and misroute "order booking" to the
      // generic Bookings flow instead of the clinic Appointment page.
      const isClinicService = Number(ezpMyProfile?.data?.[0]?.industry) === 1;

      if (allDone) {
        if (isClinicService) {
          setShowAppointmentPanel(true);
        } else {
          navigate("/vendor_bookings");
        }
        return;
      }

      for (const step of SETUP_STEPS) {
        if (!freshSteps[step.status]) {
          if (step.status === "order") {
            if (isClinicService) {
              setShowAppointmentPanel(true);
            } else {
              navigate("/vendor_bookings");
            }
          } else {
            navigate(step.route);
          }
          return;
        }
      }
    } catch (e) {
      console.log("navigateToNextPendingStep error", e);
      navigate("/setup");
    }
  };
  useEffect(() => {
    checkSetupStatus();
  }, []);
  // Phone: the header is just logo, bell and avatar. Support, Business Info,
  // Profile, Sign out and the setup prompt live in the menu sheet, which reads
  // them from here (account data) and calls back through actionsRef.
  const { isPhone } = useViewport();
  // New menu (preview): the Ctrl+K search button, and the old/new menu switch in the account menu.
  const navPrefs = useNavPrefs();
  const hasSidebar = ["2", "3", "5", "6"].includes(String(apicall.getRole()));
  const isMacKeys = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || "");
  const mobileNav = useMobileNav();
  const planLabel = getPlanLabel(vendorProfileData);
  const setupIncomplete = showAccountOwnerInfo && setupCompleted === false;
  const { setAccount } = mobileNav;

  useEffect(() => {
    setAccount({
      name: vendorName,
      plan: showAccountOwnerInfo ? planLabel : null,
      logo: vendorLogo,
      showOwnerInfo: showAccountOwnerInfo,
      setupIncomplete,
    });
  }, [vendorName, planLabel, vendorLogo, showAccountOwnerInfo, setupIncomplete, setAccount]);

  mobileNav.actionsRef.current = {
    profile: () => navigate("/vendors/view-profile"),
    businessInfo: () => setShowBusinessInfo(true),
    signOut: confirmLogout,
    finishSetup: navigateToNextPendingStep,
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top custom-border-bottom py-2">
        <div className="container-fluid px-3 px-lg-4 d-flex justify-content-between align-items-center navbar-responsive">
          <div className="d-flex align-items-center flex-shrink-0">
            <BrandLogo height={32} />
            {hasSidebar && navPrefs.version === "v2" && !isPhone && (
              <button type="button" className="nv2-navbar-search d-none d-md-flex" onClick={openNavSearch} aria-label="Search pages">
                <LuSearch size={16} />
                <span>Search or jump to…</span>
                <span className="nv2-kbd">{isMacKeys ? "⌘K" : "Ctrl K"}</span>
              </button>
            )}
          </div>

          {/* Right Side Items */}
          <div className="d-flex align-items-center gap-1 flex-nowrap">
            {/* Search Bar */}
            {/* <div className="d-none d-md-block navbar-search-bar">
            <div
              className="position-relative"
              style={{
                width:
                  typeof window !== "undefined" &&
                  window.innerWidth >= 768 &&
                  window.innerWidth <= 1024
                    ? showSearch
                      ? "200px"
                      : "44px"
                    : showSearch
                    ? "320px"
                    : "44px",
              }}
            >
              <LuSearch
                onClick={() => setShowSearch((prev) => !prev)}
                className="position-absolute"
                style={{
                  left: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#000",
                  cursor: "pointer",
                  zIndex: 2,
                }}
              />
              <input
                type="text"
                className={`form-control ps-5 ${showSearch ? "" : "d-none"}`}
                placeholder="Search for doctors"
                value={searchQuery}
                onChange={handleSearch}
                onKeyDown={handleSearchSubmit}
                autoFocus={showSearch}
                style={{
                  borderRadius: "8px",
                  height: "44px",
                  backgroundColor: "#F5F5F5",
                  border: "none",
                  fontSize: "14px",
                }}
              />
            </div>
          </div> */}
            {showAccountOwnerInfo && !isPhone && (setupCompleted ? (
              <span
                className="navbar-action-pill"
                style={{
                  color: "#059669",
                  backgroundColor: "#ECFDF5"
                }}
                onClick={() => {
                  // isClinicService is already kept fresh by the
                  // fetchVendorProfile effect on every Navbar mount — no need
                  // to block this click on a new network round trip just to
                  // re-derive the same value (that was adding a multi-second
                  // delay before the page even started navigating).
                  if (isClinicService) {
                    setShowAppointmentPanel(true);
                  } else {
                    navigate("/vendor_bookings");
                  }
                }}
              >
                {isClinicService ? "Book Appointment" : "Start Booking"}
              </span>
            ) : (
              <span
                className="navbar-action-pill"
                style={{
                  color: "#B45309",
                  backgroundColor: "#FFFBEB"
                }}
                onClick={navigateToNextPendingStep}
              >
                Setup Incomplete
              </span>
            ))}

            {!isPhone && <div className="navbar-icon-divider" />}

            {!isPhone && (
            <div className="position-relative" ref={supportRef}>
              <BiSupport
                className="navbar-icon-btn"
                style={{
                  width: "34px",
                  height: "34px",
                  cursor: "pointer",
                  color: "#4B5563"
                }}
                onClick={() => setSupport((prev) => !prev)}
                title="Support"
              />
              {support && (
                <div
                  style={{
                    position: "fixed",
                    top: "calc(var(--navbar-h, 64px) + var(--banner-h, 0px))",
                    right: "12px",
                    // width: "420px",
                    maxHeight: "calc(100dvh - var(--navbar-h, 64px) - var(--banner-h, 0px))",
                    background: "#fff",
                    borderLeft: "1px solid #E3EBF8",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    zIndex: 2000,
                    overflowY: "auto",
                    padding: "16px"
                  }}
                >
                  <div>Email: sales@ezeitpro.com</div>
                </div>
              )}
            </div>
            )}
            {isHomeService && !isPhone && (
              <div className="position-relative" ref={helpRef}>
                <IoIosHelpCircle
                  className="navbar-icon-btn"
                  style={{
                    width: "34px",
                    height: "34px",
                    cursor: "pointer",
                    color: "#4B5563"
                  }}
                  onClick={() => setShowHelp((prev) => !prev)}
                  title="Video Tutorials"
                />
                {showHelp && <HelpPanel onClose={() => setShowHelp(false)} />}
              </div>
            )}

            {!isPhone && (
              <MdOutlineBusinessCenter
                className="navbar-icon-btn"
                style={{
                  width: "34px",
                  height: "34px",
                  cursor: "pointer",
                  color: "#4B5563"
                }}
                onClick={() => setShowBusinessInfo(true)}
                title="Business Information"
              />
            )}

            <div className="position-relative" ref={bellRef}>
              <LuBell
                className="navbar-icon-btn"
                style={{
                  fontSize: "34px",
                  color: "#4B5563",
                  cursor: "pointer"
                }}
                onClick={() => setShowNotifications((prev) => !prev)}
              />
              {unreadCount > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style={{ fontSize: "10px", padding: "3px 5px" }}
                >
                  {unreadCount}
                </span>
              )}
              {showNotifications && (
                <div
                  style={{
                    position: "fixed",
                    top: "calc(var(--navbar-h, 64px) + var(--banner-h, 0px))",
                    right: 0,
                    width: "min(420px, 100vw)",
                    maxHeight: "calc(100dvh - var(--navbar-h, 64px) - var(--banner-h, 0px))",
                    background: "#fff",
                    borderLeft: "1px solid #E3EBF8",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    zIndex: 2000,
                    overflowY: "auto",
                    padding: "16px"
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontWeight: 600 }}>Notifications</span>
                    {notifications.length > 0 && (
                      <button
                        className="btn btn-link p-0"
                        style={{
                          fontSize: "13px",
                          color: "#1D4ED8",
                          textDecoration: "none"
                        }}
                        onClick={deleteAllNotifications}
                      >
                        Clear All
                      </button>
                    )}
                  </div>

                  {notifications.length === 0 ? (
                    <div
                      style={{
                        textAlign: "center",
                        color: "#888",
                        marginTop: "40px"
                      }}
                    >
                      You are yet to receive notifications.
                    </div>
                  ) : (
                    <div>
                      {notifications.map((notif) => (
                        <div
                          key={notif.id}
                          style={{
                            borderBottom: "1px solid #eee",
                            padding: "12px 0",
                            cursor: "pointer",
                            backgroundColor:
                              notif.is_read === 0 ? "#f8f9fa" : "transparent",
                            position: "relative"
                          }}
                          onClick={() => {
                            if (notif.is_read === 0) {
                              markNotificationAsRead(notif.id);
                            }
                            // Procurement alerts open their screen.
                            const target = notificationTarget(notif);
                            if (target) {
                              setShowNotifications(false);
                              navigate(target);
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start"
                            }}
                          >
                            <div
                              style={{
                                paddingLeft: "10px",
                                marginRight: "10px"
                              }}
                            >
                              {notif.is_read === 0 ? (
                                <MdOutlineNotificationsActive
                                  style={{ color: "#C9194A", fontSize: "20px" }}
                                />
                              ) : (
                                <MdOutlineNotificationsNone
                                  style={{ color: "#888", fontSize: "20px" }}
                                />
                              )}
                            </div>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontWeight: 600 }}>
                                {notif.title}
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#555",
                                  paddingRight: "10px"
                                }}
                              >
                                {notif.message}
                              </div>

                              <div
                                style={{
                                  fontSize: "11px",
                                  color: "#aaa",
                                  marginTop: "2px"
                                }}
                              >
                                {new Date(notif.created).toLocaleString()}
                              </div>
                            </div>
                            <button
                              className="btn btn-link p-0"
                              style={{
                                color:
                                  hoveredDelete === notif.id
                                    ? "red"
                                    : "#dc3545",
                                position: "absolute",
                                right: "10px",
                                top: "0px",
                                transition: "color 0.2s ease"
                              }}
                              onMouseEnter={() => setHoveredDelete(notif.id)}
                              onMouseLeave={() => setHoveredDelete(null)}
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteNotification(notif.id);
                              }}
                            >
                              <RiDeleteBinLine
                                style={{
                                  fontSize: "18px",
                                  transform:
                                    hoveredDelete === notif.id
                                      ? "scale(1.1)"
                                      : "scale(1)",
                                  transition: "transform 0.2s ease"
                                }}
                              />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {isPhone ? (
              <button
                type="button"
                className="mnav-header-avatar"
                onClick={mobileNav.toggleMenu}
                aria-label="Open menu"
                aria-haspopup="dialog"
                aria-expanded={mobileNav.menuOpen}
              >
                <span className="mnav-avatar">
                  {vendorLogo ? (
                    <img src={vendorLogo} alt="" />
                  ) : (
                    (vendorName || "").trim().charAt(0).toUpperCase() || "E"
                  )}
                </span>
                {setupIncomplete && <span className="mnav-header-avatar-dot" />}
              </button>
            ) : (
              <>
            <div className="navbar-icon-divider" />

            <Dropdown align="end" className="d-flex align-items-center">
              <Dropdown.Toggle
                variant="link"
                className="p-0 border-0 bg-transparent d-flex align-items-center custom-dropdown-toggle"
                id="dropdown-user"
                style={{ textDecoration: "none" }}
              >
                {/* <div
                className="rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{
                  width: "32px",
                  height: "32px",
                  overflow: "hidden",
                  backgroundColor: vendorLogo ? "transparent" : "#1D4ED8",
                }}
              >
                {vendorLogo ? (
                  <img
                    src={vendorLogo}
                    alt={vendorName}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <span className="text-white fw-bold">
                    {vendorName?.charAt(0) || ""}
                  </span>
                )}
              </div> */}
                <div
                  className="d-flex flex-column align-items-start"
                  style={{ lineHeight: 1.3 }}
                >
                  <span
                    className="fw-bold"
                    style={{ fontSize: "15px", color: "#111827" }}
                  >
                    {vendorName}
                  </span>
                  {showAccountOwnerInfo && (
                    <div style={{ fontSize: "12px" }}>
                      <span className="text-muted">
                        {getPlanLabel(vendorProfileData)}
                      </span>
                    </div>
                  )}
                </div>
                <MdKeyboardArrowDown
                  style={{
                    fontSize: "18px",
                    marginLeft: "6px",
                    color: "#9CA3AF"
                  }}
                />
              </Dropdown.Toggle>

              <style jsx="true">{`
                .custom-dropdown-toggle::after {
                  display: none !important;
                }
                .custom-dropdown-toggle,
                .custom-dropdown-toggle:hover,
                .custom-dropdown-toggle:focus,
                .custom-dropdown-toggle:active {
                  text-decoration: none !important;
                  color: inherit !important;
                  box-shadow: none !important;
                }
                /* Narrow windows: keep the account menu on screen, under the header.
                   Scoped to this navbar - it used to restyle every .dropdown-menu in
                   the app, and top:10px put it over the header itself. */
                @media (max-width: 767.98px) {
                  .navbar .dropdown-menu {
                    position: fixed !important;
                    top: calc(var(--navbar-h, 64px) + var(--banner-h, 0px) + 4px) !important;
                    width: 95% !important;
                    left: auto;
                    right: 12px;
                    max-width: 300px;
                    z-index: 3000;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                  }
                }
              `}</style>

              <Dropdown.Menu style={{ marginTop: "8px" }}>
                {showAccountOwnerInfo && (
                  <Dropdown.Item
                    onClick={() => navigate("/vendors/view-profile")}
                    className="d-flex align-items-center gap-2"
                  >
                    <MdPersonOutline style={{ fontSize: "24px" }} />
                    <span className="form-labels">Profile</span>
                  </Dropdown.Item>
                )}

                {hasSidebar && !isPhone && (
                  <Dropdown.Item
                    onClick={() => navPrefs.setVersion(navPrefs.version === "v2" ? "v1" : "v2")}
                    className="d-flex align-items-center gap-2"
                  >
                    <MdOutlineViewSidebar style={{ fontSize: "24px" }} />
                    <span className="form-labels">{navPrefs.version === "v2" ? "Switch to old menu" : "Try the new menu"}</span>
                  </Dropdown.Item>
                )}

                <Dropdown.Item
                  onClick={confirmLogout}
                  className="d-flex align-items-center gap-2"
                >
                  <TbLogout style={{ fontSize: "24px" }} />
                  <span className="form-labels">Sign-Out</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
              </>
            )}
          </div>
        </div>

        {/* Mobile Search */}
        {/* <div className="container-fluid px-3 d-md-none mt-2">
        <div
          className="position-relative"
          style={{ maxWidth: "320px", width: "100%" }}
        >
          <FaSearch
            className="position-absolute"
            style={{
              left: "16px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#8C8C8C",
            }}
          />
          <input
            type="text"
            className="form-control ps-5"
            placeholder="Search for doctors"
            value={searchQuery}
            onChange={handleSearch}
            onKeyDown={handleSearchSubmit}
            style={{
              borderRadius: "8px",
              height: "44px",
              backgroundColor: "#F5F5F5",
              border: "none",
              fontSize: "14px",
            }}
          />
        </div>
      </div> */}
        <style jsx="true">{`
          .navbar-action-pill {
            font-weight: 600;
            font-size: 13px;
            cursor: pointer;
            padding: 6px 14px;
            border-radius: 20px;
            white-space: nowrap;
            transition: filter 0.15s ease;
          }
          .navbar-action-pill:hover {
            filter: brightness(0.96);
          }
          .navbar-icon-divider {
            width: 1px;
            height: 24px;
            background-color: #e5e7eb;
            margin: 0 4px;
            flex-shrink: 0;
          }
          .navbar-icon-btn {
            padding: 7px;
            border-radius: 50%;
            transition: background-color 0.15s ease;
          }
          .navbar-icon-btn:hover {
            background-color: #f3f4f6;
          }
          @media (pointer: coarse) {
            .navbar-icon-btn {
              width: 44px !important;
              height: 44px !important;
              padding: 10px !important;
            }
            .navbar-action-pill {
              display: inline-flex;
              align-items: center;
              min-height: 44px;
            }
          }
          /* Mobile tweaks: shrink spacing, font sizes, icons */
          @media (max-width: 767.98px) {
            .navbar-responsive {
              flex-wrap: nowrap;
            }
            .navbar-responsive > div,
            .navbar-responsive > div > span,
            .navbar-responsive > div > a {
              white-space: nowrap;
              font-size: 12px;
            }
            .support-popup {
              position: fixed;
              top: 63px;
              right: 12px;
              max-height: calc(100vh - 63px);
              background: #fff;
              border-left: 1px solid #e3ebf8;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
              z-index: 2000;
              overflow-y: auto;
              padding: 12px;
            }
          }
        `}</style>
      </nav>

      {/* Sign-Out Confirmation Modal */}
      <Modal
        show={showLogoutConfirm}
        onHide={() => setShowLogoutConfirm(false)}
        centered
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
            Sign Out
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "14px" }}>
          Are you sure you want to sign out?
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "none", paddingTop: 0 }}>
          <Button
            variant="light"
            size="sm"
            onClick={() => setShowLogoutConfirm(false)}
            style={{ minWidth: "80px" }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={handleLogout}
            style={{ minWidth: "80px" }}
          >
            Sign Out
          </Button>
        </Modal.Footer>
      </Modal>

      <Offcanvas
        show={showAppointmentPanel}
        onHide={() => setShowAppointmentPanel(false)}
        placement="end"
        backdrop={true}
        style={{
          width: "min(500px, 100vw)",
          minWidth: "min(500px, 100vw)",
          maxWidth: "min(500px, 100vw)",
          flexShrink: 0
        }}
      >
        <Offcanvas.Header closeButton className="custom-border-bottom p-4">
          <Offcanvas.Title className="page-heading">
            New Appointment
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0 d-flex flex-column">
          <div className="appointment-card">
            <div className="appointment-body">
              {showAppointmentPanel && (
                <NewAppointment
                  onClose={() => setShowAppointmentPanel(false)}
                  mode="new"
                />
              )}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <BusinessInfoSidebar
        show={showBusinessInfo}
        onHide={() => setShowBusinessInfo(false)}
        vendorData={vendorProfileData}
      />
    </>
  );
};

export default Navbar;
